
import gallerySwiperVue from '@/components/gallerySwiper.vue';
import comment from '@/components/comment.vue';

export default {
    components: { gallerySwiperVue, comment, },
    name: 'index',
    head() {
        // 优化seo：动态设置title，keywords 和 description
        //  property: "og:xxxx" 是facebook分享 图谱抓取的内容
        //  name="twitter:site" twitter  图谱抓取的内容
        //fackbook分享调试器 https://developers.facebook.com/tools/debug/
        return {
            title: 'preview',
        };
    },
    data() {
        return {
            source: {},
            followLoading: false,
            uid: '',
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                autoplay: false,
                muted: false,
                loop: false,
                preload: 'auto',
                language: 'zh-CN',
                aspectRatio: '16:9',
                fluid: true,
                sources: [
                    { type: 'video/mp4', src: '' }
                ],
                poster: '',
                width: '100%',
                notSupportedMessage: '',
            },
            interval: 5000
        };
    },
    created() {
        this.uid = process.client ? this.$store.state.userInfo?.userInfo?.uid : ''
        this.playerOptions.notSupportedMessage = this.$t('page.VIDEO_UNAVAILABLE')
        this.carouselChange(0)

    },

    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.source = JSON.parse(localStorage.getItem('previewWord'))
            this.source.works_images = this.source.type == 1 ? this.source.imagePath.split(',') : this.source.imagePath
            this.source.tag = this.source.tag == '' ? [] : this.source.tag.split(',')
            this.playerOptions.sources[0].src = this.source.type == 2 ? this.source.imagePath : ''
            this.playerOptions.poster = this.source.type == 2 ? this.source.coverImagePath : ''

        },
        onPlayerPlay(player) { },
        onPlayerPause(player) { },
        carouselChange(item) {
            this.$store.commit('SET_CAROUSEL_index', item)
        },
        thumbnailMouseover(index) {
            this.$store.commit('SET_CAROUSEL_index', index)
        },
        exitPreview() {
            //关闭当前页面
            window.open('', '_self'); window.close();

        }

    },
    watch: {
        carouselIndex(item) {
            this.$refs.carousel?.setActiveItem(item);
            this.$store.commit('SET_CAROUSEL_index', item)

        }
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        },
        carouselIndex() {
            return this.$store.state.carouselIndex
        }
    }


}
